export default __webpack_public_path__ + "static/media/click1.27ac7609.aac";